/**
 * Generated runtime TestId mirror for frontend/src/components/layout/SidebarNav.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const SidebarNavId = {
  AccessProfiles: "access-profiles",
  AccessRequests: "access-requests",
  Accounts: "accounts",
  ApprovalPolicies: "approval-policies",
  AttributeDefinitions: "attribute-definitions",
  AutoAssignRuleRequests: "auto-assign-rule-requests",
  AutoAssignRules: "auto-assign-rules",
  Caches: "caches",
  CertificationDashboard: "certification-dashboard",
  CertificationPolicies: "certification-policies",
  CertificationReviews: "certification-reviews",
  Cluster: "cluster",
  Compare: "compare",
  Delegations: "delegations",
  EffectiveAccessDashboard: "effective-access-dashboard",
  EffectiveAccessIdentities: "effective-access-identities",
  EffectiveAccessSystems: "effective-access-systems",
  EnforcementObjects: "enforcement-objects",
  ErrorLogs: "error-logs",
  Executions: "executions",
  FormLayouts: "form-layouts",
  FunctionGroupRequests: "function-group-requests",
  FunctionGroups: "function-groups",
  History: "history",
  Identities: "identities",
  InboundConnectorConfigConnection: "inbound-connector-config-connection",
  InboundConnectorConfigOperations: "inbound-connector-config-operations",
  InboundConnectorConfigReconciliation: "inbound-connector-config-reconciliation",
  InboundConnectors: "inbound-connectors",
  Jobs: "jobs",
  JobsDashboard: "jobs-dashboard",
  LifecycleEvents: "lifecycle-events",
  LlmPrompts: "llm-prompts",
  MyAccess: "my-access",
  MyApprovals: "my-approvals",
  MyDashboard: "my-dashboard",
  MyDelegations: "my-delegations",
  MyNotifications: "my-notifications",
  MyRehires: "my-rehires",
  MyRequests: "my-requests",
  MyResponsibilities: "my-responsibilities",
  MyReviews: "my-reviews",
  NotificationLog: "notification-log",
  NotificationTemplates: "notification-templates",
  Onboarding: "onboarding",
  OutboundConnectors: "outbound-connectors",
  Parties: "parties",
  ProvisioningDashboard: "provisioning-dashboard",
  RehireReview: "rehire-review",
  RelationshipSchema: "relationship-schema",
  ReportCategories: "report-categories",
  RequestInspector: "request-inspector",
  Resources: "resources",
  RestrictionRuleRequests: "restriction-rule-requests",
  RestrictionRules: "restriction-rules",
  RoleAssignments: "role-assignments",
  Roles: "roles",
  SchemaPolicies: "schema-policies",
  SchemaViolations: "schema-violations",
  ScriptExecuteLog: "script-execute-log",
  ServiceAccounts: "service-accounts",
  Systems: "systems",
  Tasks: "tasks",
  TestData: "test-data",
  Types: "types",
  ValueLists: "value-lists",
  ViolationsDashboard: "violations-dashboard",
} as const;
export type SidebarNavId = typeof SidebarNavId[keyof typeof SidebarNavId];

export const SidebarNavTestIds = {
  linkNav: (subtype: SidebarNavId) => `link-nav-${subtype}` as const,
  linkNavPrefix: () => "link-nav-" as TestIdPrefix
} as const;
